

export default new class Analytics {

    constructor() {

    }

    trackEvent(category, action, label) {
        if (dataLayer) {
            dataLayer.push({
                event: 'trackEvent',
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label
            });
        }
    }


    listenTrackLinks() {
        const $links = $('.analytic');

        $links.click(e => {
            const $object = $(e.currentTarget);
            const category = $object.data('category');
            const action = $object.data('action');
            const label = $object.data('label');

            this.trackEvent(category, action, label);
            console.log('track event link');


        });

    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Analytics.js